// Returns an array containing [min, min+1, min+2, ..., max]
export var getRangeArray = function (min, max) {
    var len = max - min + 1;
    var arr = new Array(len);
    for (var i = 0; i < len; i++) {
        arr[i] = min + i;
    }
    return arr;
};
